<template>
    <div class="app-download-page">
        <div class="hero">
            <h1>{{ info.app_name || '导航盒子' }}</h1>
            <p class="version" v-if="info.version">当前版本 {{ info.version }}</p>
            <p class="domain" v-if="info.domain">下载域名：{{ info.domain }}</p>
        </div>

        <div class="download-card">
            <a
                v-if="info.android_url"
                href="javascript:void(0)"
                class="download-btn android"
                @click="downloadByPlatform('android')"
            >Android 下载</a>
            <a
                v-if="info.ios_url"
                href="javascript:void(0)"
                class="download-btn ios"
                @click="downloadByPlatform('ios')"
            >iOS 下载</a>
            <div v-if="!info.android_url && !info.ios_url" class="empty-tip">暂未配置下载地址</div>
        </div>

        <div class="note-card">
            <div class="note-title">更新说明</div>
            <div class="note-content">{{ info.update_note || '暂无更新说明' }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppDownloadPage',
    data() {
        return {
            info: {
                app_name: '导航盒子',
                domain: '',
                android_url: '',
                ios_url: '',
                version: '',
                update_note: ''
            },
            deviceId: '',
            agentCode: ''
        }
    },
    methods: {
        resolveAgentCode() {
            this.agentCode = String(this.$route.query.dl || '').trim().slice(0, 64)
        },
        ensureDeviceId() {
            const key = 'app_download_device_id'
            let value = localStorage.getItem(key)
            if (!value) {
                value = `dv_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
                localStorage.setItem(key, value)
            }
            this.deviceId = value
        },
        detectPlatform() {
            const ua = (navigator.userAgent || '').toLowerCase()
            if (/android/.test(ua)) return 'android'
            if (/iphone|ipad|ipod|ios/.test(ua)) return 'ios'
            return 'other'
        },
        reportEvent(eventType, ext = {}) {
            this.$http.post('/app_data_report', {
                device_id: this.deviceId,
                platform: this.detectPlatform(),
                event_type: eventType,
                agent_code: this.agentCode,
                ...ext
            }).catch(() => {
                // 上报失败不阻断页面流程
            })
        },
        loadDownloadConfig() {
            this.$http.get('/download_manage_current').then(({ data: res }) => {
                if (res.status !== 200 || !res.data) return
                this.info = {
                    ...this.info,
                    ...res.data
                }
            })
        },
        downloadByPlatform(platform) {
            const url = platform === 'ios' ? this.info.ios_url : this.info.android_url
            if (!url) return
            this.reportEvent('click', { click_platform: platform })
            window.open(url, '_blank')
        }
    },
    created() {
        this.resolveAgentCode()
        this.ensureDeviceId()
        this.loadDownloadConfig()
        this.reportEvent('visit')
    }
}
</script>

<style lang="less" scoped>
.app-download-page {
    min-height: calc(100vh - 9rem);
    padding: 1.2rem;
    padding-bottom: 6rem;
    background: transparent;
}
.hero {
    margin: .35rem 0 1rem;
    padding: 1.1rem;
    border-radius: 1rem;
    background: linear-gradient(130deg, #0f5964, #2d7b84 50%, #dd6f24);
    box-shadow: 0 16px 30px rgba(15, 89, 100, .24);
    h1 {
        font-size: 1.7rem;
        color: #fff;
        line-height: 1.3;
        letter-spacing: .04rem;
    }
    .version,
    .domain {
        margin-top: .45rem;
        font-size: .92rem;
        color: rgba(255, 255, 255, .92);
    }
}
.download-card,
.note-card {
    background: var(--a-surface);
    border-radius: 1rem;
    border: 1px solid rgba(255, 255, 255, .65);
    box-shadow: var(--a-shadow);
    padding: 1rem;
    margin-bottom: 1rem;
}
.download-btn {
    display: block;
    width: 100%;
    text-align: center;
    line-height: 2.9rem;
    border-radius: 3rem;
    margin-bottom: .8rem;
    color: #fff;
    font-weight: 700;
    letter-spacing: .04rem;
    box-shadow: 0 10px 16px rgba(24, 59, 65, .22);
}
.download-btn.android {
    background: linear-gradient(125deg, #0f5964, #2b8a7b);
}
.download-btn.ios {
    background: linear-gradient(125deg, #dd6f24, #ca9142);
}
.empty-tip {
    text-align: center;
    color: #6f6860;
    padding: 1.5rem 0;
}
.note-title {
    font-size: 1.1rem;
    font-weight: 800;
    color: #173d42;
    margin-bottom: .5rem;
}
.note-content {
    font-size: .95rem;
    color: #5f5a53;
    line-height: 1.7;
    white-space: pre-wrap;
}
</style>
